import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ResEqualizerChartComponent } from './res-equalizer-chart/res-equalizer-chart.component';
import { ResPolarChartComponent } from './res-polar-chart/res-polar-chart.component';
import { ResHeatmapChartComponent } from './res-heatmap-chart/res-heatmap-chart.component';
import { ResBlinksChartComponent } from './res-blinks-chart/res-blinks-chart.component';
import { ResEmotionChartComponent } from './res-emotion-chart/res-emotion-chart.component';
import { ResLeaksChartComponent } from './res-leaks-chart/res-leaks-chart.component';
import { ResVoiceChartComponent } from './res-voice-chart/res-voice-chart.component';
import { ResRgbChartComponent } from './res-rgb-chart/res-rgb-chart.component';
import { ResLeaksExtendedComponent } from './res-leaks-extended/res-leaks-extended.component';
import { ResHnebChartComponent } from './res-hneb-chart/res-hneb-chart.component';
import { ResChatBotComponent } from './res-chat-bot/res-chat-bot.component';
import { ResQHeatmapChartComponent } from './res-q-heatmap-chart/res-q-heatmap-chart.component';
import { ResBlinksHeatmapComponent } from './res-blinks-heatmap/res-blinks-heatmap.component';
import { ResSquintHeatmapComponent } from './res-squint-heatmap/res-squint-heatmap.component';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from 'src/app/services/shared.service';
import { GenerateNewReportComponent } from '../report-generation/generate-new-report/generate-new-report.component';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-research-data',
    templateUrl: './research-data.component.html',
    styleUrl: './research-data.component.scss',
    standalone: false
})
export class ResearchDataComponent implements OnInit, OnChanges {
	@ViewChild('responseModal') responseModal!: TemplateRef<any>;
	
	@ViewChild('videoElement', { static: false }) videoElement!: ElementRef;

  @ViewChild('convEqulizerChart') convEqulizerChart!: ResEqualizerChartComponent;
  @ViewChild('convPolarChart') convPolarChart!: ResPolarChartComponent;

	@ViewChild('convHeatmapChart') convHeatmapChart!: ResHeatmapChartComponent;
	
	@ViewChild('convBlinksChart') convBlinksChart!: ResBlinksChartComponent;
  @ViewChild('convVoiceChart') convVoiceChart!: ResVoiceChartComponent;
  @ViewChild('convLeaksChart') convLeaksChart!: ResLeaksChartComponent;
	@ViewChild('convEmotionChart') convEmotionChart!: ResEmotionChartComponent;
  @ViewChild('convSkinChart') convSkinChart!: ResRgbChartComponent;
	
  @ViewChild('convLeaksExtended') convLeaksExtended!: ResLeaksExtendedComponent;
  @ViewChild('convHeadNoseEyeBrow') convHeadNoseEyeBrow!: ResHnebChartComponent;
  @ViewChild('convHeadPosition') convHeadPosition!: ResHnebChartComponent;
	
  @ViewChild('convQHeatmapChart') convQHeatmapChart!: ResQHeatmapChartComponent;
  @ViewChild('convChatBot') convChatBot!: ResChatBotComponent;
	
	@ViewChild('convBlinksHeatmap') convBlinksHeatmap!: ResBlinksHeatmapComponent;
	@ViewChild('convSquintHeatmap') convSquintHeatmap!: ResSquintHeatmapComponent;

	@ViewChild('generateNewReport') generateNewReportModal!: GenerateNewReportComponent;

	@Output() updateReportsEvent = new EventEmitter<string>()
	@Output() reportOpened = new EventEmitter<void>();

	@Input() conversation: any;
	@Input() conversation_data: any;
	@Input() page_source!: string;
	@Input() page_data!: any;
	@Input() allowSpecial: boolean = false;
	@Input() targetReportId: string | null = null;

	url_service: any = null;

	currentTime = 0;
	canvasLabel = '';
	canvasLabels: any = [];
	deepHeatmap!: any;

	activeId = 1;
	isVideoBroken = false;
	totalDuration = 0;

	global_chart_show = false;
	voice_chart_show = false;
	leaks_chart_show = false;
	blinks_chart_show = false;
	skin_chart_show = false;
	deep_chart_show = false;
	feelings_chart_show = false;
	events_chart_show = false;
	polar_chart_show = false;
	leaks_extended_show = false;
	head_nose_eyebrow_show = false;
	head_position_show = false;
	q_heatmap_chart_show = false;
	new_leaks_chart_show = false;

	selectedCategory: any = null;
	categories: any[] = [];
	categoryIndex = 0;

	resultsWithTimeline: any[] = [];
	qna_series: any[] = [];
	qna_default_series: any[] = [];

	selectedFaceArea: any = { label: 'Blinks', value: 'blinks' };
	face_areas: any[] = [
		{ label: 'Blinks', value: 'blinks' },
		{ label: 'Squints', value: 'squints' },
		{ label: 'Head', value: 'head' }
	];

	deleteModalRef: any;
	submitted = false;
  spinner = false;
  success = false;
  message: string = '';
	delete_video_url: string = '';
	reanalyze_url: string = '';

	isVersionOutdated = true;
	isResearchAdmin = this.authService.role === 'ADMIN';

	constructor(private cdr: ChangeDetectorRef, private router: Router, private modalService: NgbModal, private sharedService: SharedService, private authService: AuthService) {}

	async ngOnInit() {
		this.url_service = this.buildURLs();

		if (!this.url_service) {
			this.router.navigate(['/']);
		}

		this.canvasLabels = this.conversation_data.indications;

		if (this.allowSpecial) {
			if (this.conversation_data.get_leaks_long_short) {
				this.categories = [
					{ label: 'Brows', value: 'brows' },
					{ label: 'Cheeks', value: 'cheeks' },
					{ label: 'Eyes (Blink/Squint/Wide)', value: 'eyes_blink_squint_wide' },
					{ label: 'Eyes (Gaze)', value: 'eyes_general' },
					{ label: 'Jaw', value: 'jaw' },
					{ label: 'Mouth (General)', value: 'mouth_general' },
					{ label: 'Mouth (Emotions)', value: 'mouth_emotions' },
					{ label: 'Mouth (Lips)', value: 'mouth_lips' },
					{ label: 'Nose', value: 'nose' }
				];

				this.selectedCategory = this.categories[0];
			}	
		}

		if (this.conversation_data.questions_and_answers) {
			this.resultsWithTimeline = this.conversation_data.questions_and_answers.map((qa: { intervals: [number, number][]; answer: string; }) => {
				const timeline = Array(this.conversation_data.rgbData.length).fill(0);
				qa.intervals.forEach(([start, end]: [number, number]) => {
					for (let colIndex = start; colIndex <= end; colIndex++) {
						if (colIndex >= 0 && colIndex < timeline.length) {
							timeline[colIndex] = 100;
						}
					}
				});
	
				return {
					answer: qa.answer,
					intervals: qa.intervals,
					timeline: timeline
				};
			});
	
			this.qna_series = Array.from({ length: this.conversation_data.questions_and_answers.length }, (_, index) => ({
				name: this.conversation_data.questions_and_answers[index].title,
				question: this.conversation_data.questions_and_answers[index].name,
				value: this.conversation_data.questions_and_answers[index].intervals.length > 0,
				original: 0
			}));
	
			this.qna_default_series = Array.from({ length: this.conversation_data.questions_and_answers.length }, (_, index) => ({
				name: this.conversation_data.questions_and_answers[index].title,
				value: 0,
				original: 0
			}));
		}

		if (this.canvasLabels.length > 0) {
			this.canvasLabel = this.canvasLabels[0];
		}

		if (this.conversation_data.rgbData) {
			this.totalDuration = this.conversation_data.rgbData.length;
		}

		if (!this.conversation_data.video_url) {
			console.warn("Video URL is missing. Switching to Manual Mode.");
			this.isVideoBroken = true;
		}

		await this.setChartsShow();

		if (!this.isVideoBroken) {
			const interval = setInterval(() => {
				if (this.videoElement) {
					clearInterval(interval);
					this.setupVideoElement();
				}
			}, 1000);
		} else {
			this.cdr.detectChanges();
			
			if (this.polar_chart_show && this.convPolarChart) {
        this.convPolarChart.showChart();
        this.convPolarChart.updateChart(this.currentTime);
      }

			this.switchTab(true); 
		}
	}

	ngOnChanges(changes: SimpleChanges): void {
    if (changes['targetReportId'] && this.targetReportId) {
      this.activeId = 7;
      this.cdr.detectChanges();
    }
  }

	camelCaseToTitleCase(text: string) {
		// 1. Insert spaces before each uppercase letter (except the first one).
		const spacedString = text.replace(/([A-Z])/g, ' $1');
	
		// 2. Capitalize the first letter.
		const titleCaseString = spacedString.charAt(0).toUpperCase() + spacedString.slice(1);
	
		return titleCaseString;
	}

	async getMaxBlinks(arr: any) {
		const blinksArray = this.conversation_data.blinksData.map((obj: any) => obj.blinks);
		const maxBlinks = Math.max(...blinksArray);

		return Math.ceil(maxBlinks);
	}

	async setChartsShow() {
		this.new_leaks_chart_show = true;

		if (this.conversation_data.global_heatmap && this.conversation_data.voice2Data && this.conversation_data.voicePitch2Data) {
			this.global_chart_show = this.conversation_data.global_heatmap.length > 0 && this.conversation_data.voice2Data.length > 0 && this.conversation_data.voicePitch2Data.length > 0;
		}

		if (this.conversation_data.voiceData && this.conversation_data.voicePitchData && this.conversation_data.voiceSegmentData) {
			this.voice_chart_show = this.conversation_data.voiceData.length > 0 && this.conversation_data.voicePitchData.length > 0 && this.conversation_data.voiceSegmentData.length > 0;
		}

		if (this.conversation_data.heatmap_leaks) {
			this.leaks_chart_show = this.conversation_data.heatmap_leaks.length > 0;
		}

		if (this.conversation_data.blinksData) {
			this.blinks_chart_show = this.conversation_data.blinksData.length > 0;
		}

		if (this.conversation_data.smoothed_rgb) {
			if (!this.blinks_chart_show) {
				this.blinks_chart_show = this.conversation_data.smoothed_rgb.smoothed_cog.length > 0 && this.conversation_data.smoothed_rgb.smoothed_emo.length > 0;
			}
		}

		if (this.conversation_data.rgbData) {
			this.skin_chart_show = this.conversation_data.rgbData.length > 0;
		}

		if (this.conversation_data.heatmap_switches && this.conversation_data.heatmap_leaks_event) {
			this.deep_chart_show = this.conversation_data.heatmap_switches.length > 0 && this.conversation_data.heatmap_leaks_event.length > 0;
		}

		if (this.conversation_data.emotionData) {
			this.feelings_chart_show = this.conversation_data.emotionData.length > 0;
		}
		
		if (this.conversation_data.templates_heatmap_all && this.conversation_data.heatmap_switches) {
			this.events_chart_show = this.conversation_data.templates_heatmap_all.length > 0 && this.conversation_data.heatmap_switches.length > 0;
		}
		
		if (this.conversation_data.rgbData && this.conversation_data.blinksData && this.conversation_data.heatmap_leaks) {
			this.polar_chart_show = this.conversation_data.rgbData.length > 0 && this.conversation_data.blinksData.length > 0 && this.conversation_data.heatmap_leaks.length > 0;
		}
		
		if (this.allowSpecial && this.conversation_data.get_leaks_long_short) {
			this.leaks_extended_show = true;
		}

		if (this.allowSpecial && this.conversation_data.head_nose_eyebrow) {
			this.head_nose_eyebrow_show = true;
		}

		if (this.allowSpecial && this.conversation_data.head_positions) {
			this.head_position_show = this.conversation_data.head_positions.length > 0;
		}

		if (this.conversation_data.questions_and_answers) {
			this.q_heatmap_chart_show = this.conversation_data.questions_and_answers.length > 0;
		}
	}

	onCategoryChange() {
		this.activeId = 9;
		this.cdr.detectChanges();
		this.switchTab();
	}

	onFaceAreaChange() {
		this.activeId = 10;
		this.cdr.detectChanges();
		this.switchTab();
	}

	updateReports(data: any) {
    this.updateReportsEvent.emit(data.entity);
  }

	switchTab(show = false, change_tab = false) {
		switch (this.activeId) {
			case 1:
				show ? this.convHeatmapChart.showHeatmap() : this.convHeatmapChart.updateHeatmap(this.currentTime);
				break;
			case 2:
				show ? this.convVoiceChart.showChart() : this.convVoiceChart.updateChart(this.currentTime);
				break;
			case 3:
				show ? this.convLeaksChart.showHeatmap() : this.convLeaksChart.updateHeatmap(this.currentTime);
				break;
			case 4:
				show ? this.convBlinksChart.showChart() : this.convBlinksChart.updateChart(this.currentTime);
				break;
			case 5:
				show ? this.convEmotionChart.showHeatmap() : this.convEmotionChart.updateHeatmap(this.currentTime);
				break;
			case 6:
				show ? this.convQHeatmapChart.showHeatmap() : this.convQHeatmapChart.updateHeatmap(this.currentTime);
				break;
			case 8:
				show ? this.convSkinChart.showChart() : this.convSkinChart.updateChart(this.currentTime);
				break;
			case 9:
				show ? this.convLeaksExtended.showHeatmap() : this.convLeaksExtended.updateHeatmap(this.currentTime);
				break;
			case 10:
				this.selectedFaceArea.value === 'head' ? (show ? this.convHeadPosition.showChart() : this.convHeadPosition.updateChart(this.currentTime)) : 
				this.selectedFaceArea.value === 'blinks' ? (show ? this.convBlinksHeatmap.showHeatmap() : this.convBlinksHeatmap.updateHeatmap(this.currentTime)) : 
				(show ? this.convSquintHeatmap.showHeatmap() : this.convSquintHeatmap.updateHeatmap(this.currentTime));
				break;
			case 11:
				show ? this.convBlinksHeatmap.showHeatmap() : this.convBlinksHeatmap.updateHeatmap(this.currentTime);
				break;
			case 12:
				show ? this.convSquintHeatmap.showHeatmap() : this.convSquintHeatmap.updateHeatmap(this.currentTime);
				break;
			case 13:
				this.isVersionOutdated = (this.conversation.extra_content?.analyze_version || 0) < 2;
				break;
		}
	}

	deepHeatmapData(data: any) {
    this.deepHeatmap = data;
  }

	polarChartWindowTime() {
    this.convPolarChart.updateChartWindowTime(this.currentTime);
  }

	changeTab(event: any) {
		this.activeId = event.nextId;
		this.cdr.detectChanges();
		this.switchTab()
	}

	onJumpToTime(time: number): void {
		// Check if we are in Video Mode or Manual Mode
		if (!this.isVideoBroken && this.videoElement) {
			const video: HTMLVideoElement = this.videoElement.nativeElement;
			video.currentTime = time;
		} else {
			// Manual Mode Logic
			this.currentTime = time;
			
			// Update labels and charts manually
			if (this.currentTime < this.canvasLabels.length) {
				this.canvasLabel = this.canvasLabels[this.currentTime];
			}
			
			if (this.polar_chart_show) {
				this.convPolarChart.updateChart(this.currentTime);
			}
			this.switchTab();
		}
	}

	setupVideoElement(): void {
		if (this.isVideoBroken || !this.conversation_data.video_url) {
			return;
  	}

    const video: HTMLVideoElement = this.videoElement.nativeElement;
		video.preload = "auto";

		if (this.polar_chart_show) {
			this.convPolarChart.showChart();
		}

    video.addEventListener('loadedmetadata', () => {
			this.switchTab(true);
    });

    video.addEventListener('timeupdate', () => {
      this.currentTime = Math.floor(video.currentTime);

			if (this.currentTime < this.canvasLabels.length) {
				this.canvasLabel = this.canvasLabels[this.currentTime];
			}

			if (this.polar_chart_show) {
				this.convPolarChart.updateChart(this.currentTime);
			}

			this.switchTab();
    });

    video.src = this.conversation_data.video_url;
  }

	onVideoError(): void {
		console.warn("Video failed to load. Switching to Manual Mode.");
		this.isVideoBroken = true;
		this.cdr.detectChanges();
		
		if (this.polar_chart_show && this.convPolarChart) {
      this.convPolarChart.showChart();
      this.convPolarChart.updateChart(this.currentTime);
    }
		
		this.switchTab(true);
	}

	onManualTimeChange(event: any): void {
		const value = event.target.value;
		this.currentTime = parseInt(value, 10);

		// Update labels manually
		if (this.currentTime < this.canvasLabels.length) {
			this.canvasLabel = this.canvasLabels[this.currentTime];
		}

		// Update charts
		if (this.polar_chart_show) {
			this.convPolarChart.updateChart(this.currentTime);
		}
		this.switchTab();
	}

	updateConversation(data: any) {
    this.updateReportsEvent.emit(data);
  }

	reanalyzeSubmit() {
    this.submitted = true;
    this.spinner = true;

    this.sharedService.reanalyze(this.reanalyze_url, 'conversation').subscribe({
			next: (data) => {
        this.submitted = false;
        this.spinner = false;
        this.success = true;
				this.authService.toastSuccessMessage(data.message, 'Re-Analyze Conversation');
        this.updateConversation(data.entity);
			},
			error: (err) => {
				this.submitted = false;
				this.spinner = false;
				this.success = false;
				this.authService.toastErrorMessage(err.message, 'Re-Analyze Conversation');
			}
		});
  }

	buildURLs() {
		switch (this.page_source) {
			case 'case':
				this.delete_video_url = `case/delete-video/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`;
				this.reanalyze_url = `case/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`;
				return {
					conversation_id: this.page_data.conversation_id,
					chatBotElbit: `case/chat-bot/elbit/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`,
					chatVertexAI: `case/chat-vertexai/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`,
					reportVertexAI: `case/report-vertexai/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`,
					smoothedRGBResults: `case/smoothed-rgb/${this.page_data.project_id}/${this.page_data.case_id}/${this.page_data.conversation_id}`,
				};
			case 'conversation':
				this.delete_video_url = `conversation/delete-video/${this.page_data.project_id}/${this.page_data.conversation_id}`;
				this.reanalyze_url = `conversation/${this.page_data.project_id}/${this.page_data.conversation_id}`;
				return {
					conversation_id: this.page_data.conversation_id,
					chatBotElbit: `conversation/chat-bot/elbit/${this.page_data.project_id}/${this.page_data.conversation_id}`,
					chatVertexAI: `conversation/chat-vertexai/${this.page_data.project_id}/${this.page_data.conversation_id}`,
					reportVertexAI: `conversation/report-vertexai/${this.page_data.project_id}/${this.page_data.conversation_id}`,
					smoothedRGBResults: `conversation/smoothed-rgb/${this.page_data.project_id}/${this.page_data.conversation_id}`,
				};
			case 'research':
				return {
					conversation_id: this.page_data.conversation_id,
					chatBotElbit: null,
					chatVertexAI: `research/chat-vertexai/${this.page_data.project_id}/${this.page_data.conversation_id}`,
					reportVertexAI: null,
					smoothedRGBResults: `research/smoothed-rgb/${this.page_data.project_id}/${this.page_data.conversation_id}`,
				};
			default:
				return null;
		}
	}

	openDeleteVideoModal(content: any) {
		this.submitted = false;
		this.success = false;
		this.spinner = false
    this.deleteModalRef = this.modalService.open(content, { size: 'l', backdrop: 'static', keyboard : false });
  }

	deleteVideo() {
		this.submitted = true;
		this.spinner = true;

    this.sharedService.deleteVideoFile(this.delete_video_url, 'conversation').subscribe({
			next: (res) => {
				this.success = true;
				this.submitted = false;
				this.spinner = false;
				this.message = res.message;
				this.deleteModalRef.close();
				this.modalService.open(this.responseModal, { size: 'l', backdrop: 'static', keyboard : false });
			},
			error: (err) => {
				this.success = false;
				this.submitted = false;
				this.spinner = false;
				this.message = err.message ? err.message : err;
				this.deleteModalRef.close();
				this.modalService.open(this.responseModal, { size: 'l', backdrop: 'static', keyboard : false });
			}
		});
	}

	async closeModal() {
		if (this.success) {
			this.conversation_data.video_url = null;
			this.isVideoBroken = true;
			this.onVideoError()
		}
		
		this.modalService.dismissAll();
	}
}
